module.exports = __webpack_public_path__ + "img/16_66.293eeacd.png";